import { render, staticRenderFns } from "./payMsg.vue?vue&type=template&id=7dfa324a&scoped=true"
import script from "./payMsg.vue?vue&type=script&lang=js"
export * from "./payMsg.vue?vue&type=script&lang=js"
import style0 from "./payMsg.vue?vue&type=style&index=0&id=7dfa324a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfa324a",
  null
  
)

export default component.exports